import axios from 'axios'
import Global from '../Global'
import MainApi, {sessionHeader} from './main.api'
import { Logging } from '../Logging'
import VueSignals from '../VueSignals';
export default class UserApi {
    constructor(){}

    static login(email = '', pw = '', token = ''){
        let data = {}
        if(token.length == 0){
           data = {
            'email': email,
            'pw':  pw,
            'session_duration': 86400
          }
        }else {
          data = {
            'token_id': token,
            'session_duration': 86400
          }
        }
          return axios
          .post(Global.GetAPIURL() + '/user/login', JSON.stringify(data)).catch(function(err) {
            if(err.response && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })

        }

    static LoggedInUserData() {
        Logging.Warn("session_id : "  + Global.getSessionID())
        Logging.Warn("session_header : " , sessionHeader)

        return axios
            .get(Global.GetAPIURL() + '/user/me', sessionHeader).catch(function(err) {
                if(err.response && err.response.status == 401){
                    Global.logout()
                    sessionStorage.setItem("invalid_session_id", true)
                }
            })
    }

    static getUsers(users_ids) {
        if(typeof users_ids != 'undefined' && users_ids.length > 0){
          let users = {
            "user_ids": users_ids
          }
          return axios
          .post(Global.GetAPIURL() + '/user/get_many', JSON.stringify(users), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
        }
    }

    static getMentions(){
        return axios
        .get(Global.GetAPIURL() + '/user/get_mentions', sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static updateUser(username, name, firstname, image){
        let data = {
            "username" : username,
            "name" : name,
            "firstname" : firstname,
            "image_doc" : image
        }
        return axios
        .post(Global.GetAPIURL() + '/user/update', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static UpdatePassword(passowrd){
        let data = {
            "password" : passowrd,
        }
        return axios
        .post(Global.GetAPIURL() + '/user/update', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static UpdateProfilePublic(status){
        let data = {
            "public" : status,
        }
        return axios
        .post(Global.GetAPIURL() + '/user/update', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static UpdateEmailSettings(doc){
        let data = {
            "emails_settings": doc
        }
        return axios
        .post(Global.GetAPIURL() + '/user/update', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static UpdateUserVisual(visuals){
        let data = {
            "chat_visuals" : visuals
        }
        return axios
        .post(Global.GetAPIURL() + '/user/update', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static getNodes(){
        let data = {
            "for_folder_creation": true      //(optional) if true it returns only nodes that can be used to create new folder
        }
        return axios
        .post(Global.GetAPIURL() + '/user/nodes', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }


    static logout(){
        return axios
        .post(Global.GetAPIURL() + '/user/logout', JSON.stringify({}), sessionHeader)
    }

    static getLoginToken(){
        let data = {
            "anonymous": false
        }
        return axios
        .post(Global.GetAPIURL() + '/user/get_login_token', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static resetPassword(email){
        let data = {
            "email": email
        }
        return axios
        .post(Global.GetAPIURL() + '/user/passwordforgotten', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }



    static RegisterInvitation(invitation_id){
        let data  = {
            "invitation_id": invitation_id,
            "accept_agb": true,
            "accept_data": true,
        }

        return axios
        .post(Global.GetAPIURL() + '/user/register', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }


    static Register(email, username, pw, firstname, lastname, companyName = ''){
        let data  = {
            "accept_agb" : true,
            "accept_data": true,
            "email": email,
            "username": username,
            "pw": pw,
            "firstname": firstname,
            "lastname": lastname,
            "company_name": companyName
        }

        if(pw != null){
            data.pw = pw
        }

        return axios
        .post(Global.GetAPIURL() + '/user/register', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static RegisterByPublicContact(contact_email = "", session_id){
        let data  = {
            "contact_email": contact_email
        }

        return axios
        .post(Global.GetAPIURL() + '/user/public_contact', JSON.stringify(data),{
            headers:{
              "session_id": session_id,
            }
        }).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static addPushSubscription(data){
        return axios
        .post(Global.GetAPIURL() + '/user/add_push_subscription', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static UpdateSession(){
        Logging.Debug("OldSessionId ", Global.getSessionID())
        return axios
        .post(Global.GetAPIURL() + '/user/session_renew', JSON.stringify({"session_duration": 86400}),sessionHeader).then(
          res => {
            if(res.data.result){
                Logging.Debug("NewSessionId ", res.data.session_id)
                Global.globalValue(VueSignals.SESSION_ID, res.data.session_id)
                Global.setSessionID(res.data.session_id)
                MainApi.setHeader()
            }
          }
        ).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }


    static ActionAnalytics(actions){
        let data = {
         "actions": actions   // actions is an array
        }
        return axios
        .post(Global.GetAPIURL() + '/user/analytics', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }
}
